import React, { useCallback, useContext, useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  Icon,
  usePopper,
  useTranslation,
  ToolTip,
} from '@testsigma/atoms';
import { FeedBack } from '../feed-back';
import { UsageDetails } from '../usage-details';
import classNames from 'classnames';
import { SessionContext } from '@contexts/session-context';

type HelpMenuProps = {
  isDisabled?: boolean;
  setIsModelopen?: (flag: boolean) => void;
};

const HelpMenu: React.FC<HelpMenuProps> = ({ isDisabled, setIsModelopen }) => {
  const { t } = useTranslation();
  const [isOpenUsage, updateIsOpenUsage] = useState(false);
  const [isOpenFeedback, updateIsOpenFeedback] = useState(false);
  const { session } = useContext(SessionContext);
  const { user } = session;
  const navigateUrl = (url) => {
    window.open(url, '_blank');
  };
  const updateFeedback = (flag: boolean) => {
    updateIsOpenFeedback(flag);
    if (setIsModelopen) setIsModelopen(flag);
  };
  const openFeedBack = useCallback(() => {
    updateIsOpenFeedback(!isOpenFeedback);
    if (setIsModelopen) setIsModelopen(true);
  }, [updateIsOpenFeedback, isOpenFeedback]);

  const openUsageDetails = useCallback(() => {
    updateIsOpenUsage(!isOpenUsage);
  }, [updateIsOpenUsage, isOpenUsage]);

  const [showDropdown, toggleDropdown] = useState(false);
  const [btnRef, setBtnRef] = useState(null);
  const offsetModifier = [
    {
      name: 'offset',
      options: {
        offset: [0, 12],
      },
    },
  ];
  const [dropdownRef, setDropdownRef] = useState(null);
  const { styles, attributes } = usePopper(btnRef, dropdownRef, {
    placement: 'right-end',
    strategy: 'fixed',
    modifiers: offsetModifier,
  });

  const navigateToUniversity = useCallback(() => {
    window.location.href = `${
      import.meta.env.VITE_ID_SERVICE_URL
    }org?university=true`;
  }, []);

  return (
    <>
      <ToolTip
        content={t('left.nav.help_support')}
        placement='top'
        align='center'
        className='inline-flex overflow-hidden justify-center border-[0.5px] rounded-md p-1.5 border-secondary-100 shadow hover:bg-secondary-50 text-unique-800 cursor-pointer bg-secondary-unique-1000'
      >
        <div
          ref={setBtnRef}
          onClick={() => toggleDropdown(true)}
          className={classNames('flex justify-center text-unique-800', {
            'pointer-events-none opacity-50': isDisabled,
          })}
        >
          <Icon name='help' className='text-[20px]' />
        </div>
      </ToolTip>
      {showDropdown && (
        <Dropdown
          className='w-[280px] z-[1000] p-md'
          toggleDropdown={toggleDropdown}
          setRef={setDropdownRef}
          style={styles.popper}
          attributes={attributes.popper}
        >
          {/* <DropdownItem
            onClick={() => openUsageDetails()}
            className="px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded"
          >
            <Icon name="donut-large" className="pr-md text-[18px]" />
            <span>{t("left.nav.usage_details")}</span>
          </DropdownItem> */}

          <DropdownItem
            onClick={() => navigateUrl('https://testsigma.com/docs/')}
            className='px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'
          >
            <Icon name='docs' className='pr-md text-[18px]' />
            <span>{t('left.nav.documentation')}</span>
          </DropdownItem>

          {!user.isGuestUser && (
            <DropdownItem
              onClick={navigateToUniversity}
              className='px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'
            >
              <Icon name='knowledge' className='pr-md text-[18px]' />
              <span>{t('left.nav.testsigma_university')}</span>
            </DropdownItem>
          )}

          <DropdownItem
            onClick={() => openFeedBack()}
            className={
              'px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'
            }
          >
            <Icon name='feedback' className='pr-md text-[18px]' />
            <span>{t('left.nav.share_feedback')}</span>
          </DropdownItem>

          <DropdownItem
            onClick={() =>
              navigateUrl('https://support.testsigma.com/a/tickets/new')
            }
            className='px-lg py-md text-[14px] flex items-center text-unique-800 hover:bg-secondary-50 rounded'
          >
            <Icon name='live-help' className='pr-md text-[18px]' />
            <span>{t('left.nav.have_question')}</span>
          </DropdownItem>
        </Dropdown>
      )}
      {isOpenUsage && (
        <UsageDetails
          isUsageModalOpen={isOpenUsage}
          setIsUsageModalOpen={updateIsOpenUsage}
        />
      )}
      <FeedBack
        isOpenFeedback={isOpenFeedback}
        updateIsOpenFeedback={updateFeedback}
      />
    </>
  );
};

export default HelpMenu;
